<div class="full-page-background">
  <p-card styleClass="hero-card component blue-section">
    <div class="hero-layout">

      <div class="hero-text">
        <h4>{{region.toUpperCase()}}</h4>
        <h1 class="hero-title">
          Stay in the know about power outages with Power Alert Service®!
        </h1>

        <!-- <button class="cta-button">
        <span class="signup-text">Sign up today!</span>
      </button> -->
      </div>

      <div class="hero-image">
        <img src="../../assets/images/hero_image.png" />
      </div>
    </div>
  </p-card>
  @if (!showPopup) {
  <div class="enroll-container">
    <div class="enroll-form">
      <h4 class="mb-4" style="font-size:2.5rem; font-weight: 700;">Enroll now!</h4>


      <p class="hero-description">
        CenterPoint Energy's proactive Power Alert Service (PAS) alerts you
        about power outages occurring at or near your address. This FREE service may send you alerts by text, phone or
        email
        about important information on incoming weather events that may impact your service and estimated time of
        restoration if your power is out.
      </p>
      <p class="hero-description">
        <em>*There is no fee for enrolling in Power Alert Service. However, by
          selecting to receive SMS/text message notifications, standard
          text messaging fees charged by your carrier may apply.</em>
      </p>
      @if (isLoading) {
      <div class="loading-container overlay">
        <p-progressSpinner strokeWidth="4">
          <style class="custom-spinner"></style>
        </p-progressSpinner>
      </div>
      }
      <form #pasLightPreferenceForm="ngForm" (ngSubmit)="onSubmit(pasLightPreferenceForm, $event)">
        <div>
          <!--Phone or Meter Number-->
          <div class="account-number-field">
            <div class="label-row">
              <span class="field-label">
                Phone Number / Meter Number
                <span class="required">*</span>
              </span>
              <button type="button" class="find-account-link" (click)="openAccountHelp('meter')">
                (Find Your Meter Number)
              </button>
            </div>

            <div class="input-container">
              <input type="text" maxlength="12" id="accountNumberField" name="accountNumberField" #phoneField="ngModel"
                [(ngModel)]="phoneMeterNumber" (blur)="validatePhoneOrMeterNumber()" [class.invalid]="phoneField.touched && !isPhoneOrMeterValid" />
              <div class="errorMessage">
                @if (phoneField.touched && !isPhoneOrMeterValid) {
                <p>{{ phoneOrMeterErrorMessage }}</p>
                }
              </div>
            </div>
          </div>
          <!--STREET NUMBER-->
          <div class="account-number-field">
            <div class="label-row">
              <span class="field-label">
                Street Number (Do not enter street name)
                <span class="required">*</span>
              </span>

              <button type="button" class="find-account-link" (click)="openAccountHelp('street')">
                (Find Your Street Number)
              </button>
            </div>

            <div class="input-container">
              <input type="text" maxlength="12" id="houseNumField" [(ngModel)]="houseNumber" #houseField="ngModel"
                (blur)="validateHouseNum()" [class.invalid]="houseField.touched && !isHouseNumValid" name="houseNumField" />
              <div class="errorMessage">
                @if (houseField.touched && !isHouseNumValid) {
                <p>{{ houseNumberErrorMessage }}</p>
                }
              </div>
            </div>
          </div>
          <div>
            <!--EMAIL-->
            <div class="account-number-field">
              <div class="label-row">
                <span class="field-label">
                  Email
                  <span class="required">*</span>
                </span>

              </div>

              <div class="input-container">
                <input type="text" id="emailField" #emailField="ngModel" [(ngModel)]="emailId" name="emailId"
                  (blur)="validateEmail()" [class.invalid]="emailField.touched && !isEmailIdValid" required />
                @if(emailField.touched && !isEmailIdValid) {
                <div class="error-message">
                  {{ emailError }}
                </div>
                }
              </div>
            </div>

          </div>
          <div class="mt-3">
            <div class="label-row">
              <span class="field-label">
                Alert me by:
              </span>
            </div>
            <div style="display:none">
              <input type="checkbox" name="email" style="width: 25px; margin-right: 10px" checked disabled />
              Email
            </div>
            <div>
              <input type="checkbox" [(ngModel)]="alertPreferences.textMessage" name="textMessage"
                style="width: 25px; margin-right: 10px" (change)="onCheckboxChange($event, 'text')" />
              Text Message
            </div>
            <div>
              <input type="checkbox" [(ngModel)]="alertPreferences.phoneCall" name="phoneCall"
                style="width: 25px; margin-right: 10px" (change)="onCheckboxChange($event, 'call')" />
              Phone Call
            </div>
          </div>
          <!--Phone TextMessage-->
          @if (alertPreferences.textMessage) {
          <div class="account-number-field mt-3">
            <div class="label-row">
              <span class="field-label">
                Phone Number for Text
                <span class="required">*</span>
              </span>

            </div>
            <div class="input-container">
              <input type="text" id="phoneField3" #phoneField="ngModel" [(ngModel)]="phoneNumberText"
                name="phoneNumberText" (blur)="validatePhoneText()" [class.invalid]="phoneField.touched && !isPhoneTextValid" required />
              @if(phoneField.touched && !isPhoneTextValid) {
              <div class="error-message">
                {{ phoneTextError }}
              </div>
              }
            </div>
          </div>
          }
          <!--Phone-->
          @if (alertPreferences.phoneCall) {          
          <div class="account-number-field mt-3">
            <div class="label-row">
              <span class="field-label">
                Phone Number for Call
                <span class="required">*</span>
              </span>

            </div>
            <div class="input-container">
              <input type="text" id="phoneField4" #phoneField="ngModel" [(ngModel)]="phoneNumberCall"
                name="phoneNumberCall" (blur)="validatePhoneCall()" [class.invalid]="phoneField.touched && !isPhoneCallValid" required />
              @if(phoneField.touched && !isPhoneCallValid) {
              <div class="error-message">
                {{ phoneCallError }}
              </div>
              }
            </div>
          </div>
          }
        </div>
        <br />
        <div style="align-items: center; gap: 10px">
          <div [class.disabled-div]="
            !pasLightPreferenceForm.valid || !ispasLightPreferenceForm
          ">
            <button class="cta-button" type="button" id="btnReCaptcha" outlined="true"
              (click)="handleSubmitButtonClick($event, pasLightPreferenceForm)">
              Sign up for PAS!
            </button>
          </div>
          <!-- <input type="button" class="p-button1" value="Reset" (click)="onReset(pasLightPreferenceForm)" /> -->
        </div>
      </form>
    </div>
  </div>
  }
  @if (showPopup) {
  <app-enrollment-response [data]="apiResponse" (closePopup)="refreshRecaptchaToken()"></app-enrollment-response>
  }
  <p-dialog [(visible)]="accountHelpVisible" [header]="accountHelpTitle" [modal]="true" [closable]="true"
    [dismissableMask]="true" [draggable]="false" [resizable]="false" styleClass="account-help-dialog">
    <img [src]="accountHelpImage" [alt]="accountHelpTitle" class="account-help-image" />
  </p-dialog>
</div>